module.exports = __webpack_public_path__ + "static/media/projects.a94013ab.svg";